
import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import { CONFIG, CONFIG_UTIL } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import ReportHwEntity from '../../../../../entity/ReportHwEntity';
import __ from 'lodash';
import Loader from '../../../../Loader';
import LoaderModal from '../../../../modal/LoaderModal';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import logo_exam from '../../homework/images/banner_homework_report_detail.png';


class DetailExamSiswa extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            isLoading: false,
            detailSiswa : {},
            kodeTa : null,
            namaJadwal : null,
            namaWaliKelas : null,
            totSkor : null,
            rataSkor : null,
            pengerjaanSiswa : []
        };
    }

    async componentDidMount() {
        console.clear();
        console.time("Time componentDidMount");
        this.setState({
            isFetching: true
        });
        await this.props.cekCookies();
        
        if(!__.isEmpty(this.props.account)) {

            // Fetch Report Exam Detail
            const fetchReportExamDetailSiswa = await accountManagement.post(CONFIG.REKAP_EXAM_DETAIL_SISWA, {
                ['idSiswa']: this.props.match.params.idSiswa,
                ['idKelasParalel']: this.props.match.params.idKp,
                ['idJadwal']: this.props.match.params.idJadwal,
            })
            .catch(function(error) {
                console.error('Error fetchReportExamDetail', error);
            });

            // Set State Report Exam Detail
            if(fetchReportExamDetailSiswa.request.readyState === 4 && fetchReportExamDetailSiswa.status === 200) {
                console.info('CEK fetchReportExamDetail', fetchReportExamDetailSiswa);
                if(fetchReportExamDetailSiswa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        detailSiswa : fetchReportExamDetailSiswa.data.data.detailSiswa,
                        pengerjaanSiswa : fetchReportExamDetailSiswa.data.data.dataSiswa,
                        namaJadwal : fetchReportExamDetailSiswa.data.data.jadwal,
                        totSkor : fetchReportExamDetailSiswa.data.data.totSkor,
                        rataSkor : fetchReportExamDetailSiswa.data.data.rata,
                        kodeTa : fetchReportExamDetailSiswa.data.data.kodeTa,
                        namaWaliKelas : fetchReportExamDetailSiswa.data.data.waliKelas,
                    });
                }
            }
        } 

        this.setState({
            isFetching: false
        });
    }

    render(){
        require('./style.css');

        return(
            <div className="page">
                <LoaderModal isFetching={this.state.isFetching}/>
                <div className="null" style={{ paddingBottom: '50px' }}>
                    {/* <div className="row">
                        <div className="col-md-12">
                            <img src={logo_exam} width="100%"></img>
                        </div>
                    </div> */}
                    <div className="row">
                        <div className="col-md-12"  style={{'text-align-last': 'center'}}>
                            <b className="header-title">
                                {this.state.detailSiswa.NAMA_SEKOLAH}
                            </b>
                            <br></br>
                            {this.state.detailSiswa.ALAMAT_SEKOLAH}
                            <br></br>
                            Email: {this.state.detailSiswa.EMAIL_SEKOLAH}
                            <br></br>
                            Telp: {this.state.detailSiswa.TELPON_SEKOLAH}
                            <br></br>
                            <li className="garis-header-4"></li>
                            <li className="garis-header-2"></li>
                        </div>
                        <div className="col-md-12 header-title-ujian" >
                            {this.state.namaJadwal}
                            <br></br>
                            Tahun Ajaran {this.state.kodeTa}
                            <br></br>                            
                        </div>
                    </div>
                    
                    <br></br>   
                    <hr/>
                    <div className="row">
                        <div className="col-md-12">
                            <table width='100%'>
                                <tr>
                                    <td width='15%'>NIS</td>
                                    <td width='2%'>:</td>
                                    <td>
                                        {
                                            this.state.detailSiswa.NIS === '0' ? "-" :
                                            this.state.detailSiswa.NIS
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td width='15%'>Nama Siswa</td>
                                    <td width='2%'>:</td>
                                    <td>{this.state.detailSiswa.NAMA_SISWA}</td>
                                </tr>
                                <tr>
                                    <td width='15%'>Kelas</td>
                                    <td width='2%'>:</td>
                                    <td>{this.state.detailSiswa.NAMA_KELAS} / {this.state.detailSiswa.NAMA_KELAS_PARALEL}</td>
                                </tr>
                                <tr>
                                    <td width='15%'>Nilai Total</td>
                                    <td width='2%'>:</td>
                                    <td>{this.state.totSkor}</td>
                                </tr>
                                <tr>
                                    <td width='15%'>Nilai Rata-Rata</td>
                                    <td width='2%'>:</td>
                                    <td>{this.state.rataSkor}</td>
                                </tr>
                            </table> 
                        </div>
                    </div>
                    <hr/>

                    <div className="row footer-text">
                        <div className="col-md-12">
                            <b>Mata Pelajaran</b>
                            <table className="table table-stripped">
                                <thead>
                                    <th width='5%'>No.</th>
                                    <th>Nama Mata Pelajaran</th>
                                    <th className="text-center" >Nilai</th>
                                    <th className="text-center status" >Status dikumpulkan</th>
                                </thead>
                                <tbody>
                                    {this.state.pengerjaanSiswa.map((val,i) => 
                                    <tr>
                                        <td>{i+1}</td>
                                        <td>{val.namaMapel}</td>
                                        <td className="text-center">{val.skor}</td>
                                        <td className="text-center status">{val.status === 1 ? 
                                            <i className="fa fa-check text-success" aria-hidden="true"></i> : <i className="fa fa-remove text-danger" aria-hidden="true"></i>}
                                        </td>
                                    </tr>
                                    )}                               
                                </tbody>                            
                            </table>      
                        </div>                       
                    </div>
                    
                    <hr />
                    <div className="row">
                        <table width="100%">
                            <tr>
                                <td width="60%">&nbsp;</td>
                                <td style={{'text-align-last': 'center'}}>
                                    <b>Wali Kelas</b>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <u><b>{this.state.namaWaliKelas}</b></u>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

                <div className="fixed_button">
                    <button className="btn btn-outline-info btn133w pull-right" style={{marginRight:'1em'}} onClick={() => window.print()}>Print</button>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(DetailExamSiswa);